export interface Product {
  slug: string
  name: string
  category: string
  categoryName: string
  categoryImage: string
  shortDescription: string
  technicalDescription: string
  sectors: string[]
  variants: string[]
  configuration: string
  leadTime: string
  applications: { sector: string; use: string }[]
  specifications: { field: string; value: string }[]
  image: string
  gallery: string[]
}

export const products: Product[] = [
  // Bags and Backpacks
  {
    slug: 'tactical-assault-pack',
    name: 'Tactical Assault Pack 30L',
    category: 'bags-backpacks',
    categoryName: 'Bags and Backpacks',
    categoryImage: 'PLACEHOLDER',
    shortDescription:
      'Medium-capacity patrol pack designed for durability and modularity.',
    technicalDescription:
      'Constructed from 1000D Cordura nylon with IR compliant webbing. Features a large main compartment, hydration bladder compatibility, and external MOLLE attachment points for mission-specific configuration.',
    sectors: ['defence', 'police'],
    variants: ['Multicam', 'MTP', 'Black', 'Olive Green', 'Coyote Tan'],
    configuration: 'MOLLE-compatible, hydration ready, adjustable harness',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Defence', use: '24-hour patrol pack' },
      { sector: 'Police', use: 'Tactical team equipment carriage' },
    ],
    specifications: [
      { field: 'Capacity', value: '30 Litres' },
      { field: 'Material', value: '1000D Cordura Nylon' },
      { field: 'Weight', value: '1.2 kg (approx)' },
      { field: 'Zips', value: 'YKK Heavy Duty' },
      { field: 'Buckles', value: 'ITW Nexus' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },
  {
    slug: 'patrol-day-sack',
    name: 'Patrol Day Sack 20L',
    category: 'bags-backpacks',
    categoryName: 'Bags and Backpacks',
    categoryImage: 'PLACEHOLDER',
    shortDescription:
      'Lightweight day sack for general duties and short-duration tasks.',
    technicalDescription:
      'A streamlined 20-litre pack made from 500D nylon fabric. Designed for low-profile carriage of essential equipment, featuring a padded back panel and simple waist belt for stability.',
    sectors: ['defence', 'police', 'medical'],
    variants: ['Black', 'Navy Blue', 'Olive Green'],
    configuration: 'Single main compartment, front utility pocket',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Police', use: 'General duty equipment bag' },
      { sector: 'Medical', use: 'First responder kit bag' },
    ],
    specifications: [
      { field: 'Capacity', value: '20 Litres' },
      { field: 'Material', value: '500D Nylon' },
      { field: 'Dimensions', value: '45 x 30 x 15 cm' },
      { field: 'Water Resistance', value: 'DWR Coating' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },
  {
    slug: 'modular-bergen-system',
    name: 'Modular Bergen System 100L',
    category: 'bags-backpacks',
    categoryName: 'Bags and Backpacks',
    categoryImage: 'PLACEHOLDER',
    shortDescription:
      'High-capacity load carriage system for sustained operations.',
    technicalDescription:
      'A robust 100-litre rucksack with a removable floating lid and side pouches. Built on an adjustable internal frame system to distribute heavy loads effectively, suitable for long-range patrols and deployments.',
    sectors: ['defence'],
    variants: ['MTP', 'Multicam', 'Olive Green'],
    configuration: 'Main pack + 2x 10L side pouches, PLCE compatible',
    leadTime: 'Subject to specification and order volume',
    applications: [{ sector: 'Defence', use: 'Expeditionary load carriage' }],
    specifications: [
      { field: 'Capacity', value: '100+ Litres' },
      { field: 'Frame', value: 'Internal Aluminium Stays' },
      { field: 'Fabric', value: '1000D Cordura' },
      { field: 'IRR', value: 'Compliant' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },

  // Clothing
  {
    slug: 'combat-shirt',
    name: 'Tactical Combat Shirt',
    category: 'clothing',
    categoryName: 'Clothing',
    categoryImage: 'PLACEHOLDER',
    shortDescription: 'Hybrid shirt designed for wear under body armour.',
    technicalDescription:
      'Features a moisture-wicking torso fabric for thermal regulation and durable ripstop sleeves for protection. Includes elbow pad pockets and velcro patches for identification.',
    sectors: ['defence', 'police'],
    variants: ['Sizes S-XXL', 'MTP/Olive, Black/Black, Navy/Navy'],
    configuration: 'Quarter-zip neck, adjustable cuffs',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Defence', use: 'Combat uniform under armour' },
      { sector: 'Police', use: 'Firearms officer uniform' },
    ],
    specifications: [
      { field: 'Torso Fabric', value: 'Flame Retardant Jersey' },
      { field: 'Sleeve Fabric', value: '50/50 NyCo Ripstop' },
      { field: 'Pockets', value: '2x Upper Arm' },
      { field: 'Fit', value: 'Athletic / Fitted' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },
  {
    slug: 'flame-resistant-coverall',
    name: 'Flame Resistant Coverall',
    category: 'clothing',
    categoryName: 'Clothing',
    categoryImage: 'PLACEHOLDER',
    shortDescription: 'Full-body protection for high-risk environments.',
    technicalDescription:
      'One-piece coverall manufactured from inherently flame-resistant aramid fabric. Designed to provide flash fire protection while maintaining breathability and comfort for the wearer.',
    sectors: ['defence', 'police', 'prisons'],
    variants: ['Navy Blue', 'Black', 'Sage Green', 'Sizes S-3XL'],
    configuration: 'Action back, elasticated waist, multiple pockets',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Police', use: 'Public order unit coverall' },
      { sector: 'Prisons', use: 'Cell extraction team uniform' },
    ],
    specifications: [
      { field: 'Material', value: 'Nomex / Kevlar Blend' },
      { field: 'Standards', value: 'EN ISO 11612' },
      { field: 'Closure', value: 'Two-way FR Zip' },
      { field: 'Seams', value: 'Triple Stitched' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },
  {
    slug: 'high-visibility-jacket',
    name: 'High Visibility Tactical Jacket',
    category: 'clothing',
    categoryName: 'Clothing',
    categoryImage: 'PLACEHOLDER',
    shortDescription:
      'Weatherproof jacket with high visibility for operational safety.',
    technicalDescription:
      'Waterproof and breathable jacket meeting EN ISO 20471 Class 3 standards. Features radio loops, epaulettes, and side access zips for equipment belt access.',
    sectors: ['police', 'medical'],
    variants: ['Hi-Vis Yellow', 'Hi-Vis Orange', 'Sizes XS-4XL'],
    configuration: 'Detachable hood, storm flap, equipment docks',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Police', use: 'Traffic and patrol duties' },
      { sector: 'Medical', use: 'Ambulance crew outerwear' },
    ],
    specifications: [
      { field: 'Waterproof Rating', value: '10,000mm HH' },
      { field: 'Breathability', value: '5,000g/m²/24h' },
      { field: 'Standard', value: 'EN ISO 20471 Class 3' },
      { field: 'Tape', value: 'Reflective Glass Bead' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },

  // Fire Retardants
  {
    slug: 'fr-fabric-roll',
    name: 'FR Fabric Roll Stock',
    category: 'fire-retardants',
    categoryName: 'Fire Retardants',
    categoryImage: 'PLACEHOLDER',
    shortDescription:
      'Wholesale supply of flame-retardant textiles for manufacturing.',
    technicalDescription:
      'Rolls of inherently flame-retardant fabrics or treated textiles suitable for garment manufacturing, upholstery, and protective equipment production.',
    sectors: ['defence', 'prisons'],
    variants: ['Aramid', 'Modacrylic', 'FR Cotton', 'Various Weights'],
    configuration: 'Roll width 150cm, varying lengths',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Prisons', use: 'Bedding and curtain manufacturing' },
      { sector: 'Defence', use: 'Uniform production' },
    ],
    specifications: [
      { field: 'Width', value: '150cm +/- 2cm' },
      { field: 'Weight', value: '180gsm - 350gsm' },
      { field: 'Certification', value: 'Oeko-Tex Standard 100' },
      { field: 'FR Standard', value: 'BS 5867 / EN 11612' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },
  {
    slug: 'fr-treatment-solution',
    name: 'FR Treatment Solution',
    category: 'fire-retardants',
    categoryName: 'Fire Retardants',
    categoryImage: 'PLACEHOLDER',
    shortDescription:
      'Chemical treatment services for textile fire retardancy.',
    technicalDescription:
      'Application of flame-retardant chemistry to standard fabrics to achieve compliance with fire safety standards. Suitable for natural and synthetic blends.',
    sectors: ['defence', 'prisons'],
    variants: ['Durable', 'Semi-durable', 'Non-durable'],
    configuration: 'Industrial application process',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Prisons', use: 'Retrofit treatment of soft furnishings' },
    ],
    specifications: [
      { field: 'Chemistry', value: 'Phosphorus / Nitrogen based' },
      { field: 'Durability', value: 'Up to 50 washes (Durable)' },
      { field: 'Hand Feel', value: 'Soft / Stiff options' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },
  {
    slug: 'fr-protective-hood',
    name: 'FR Protective Hood (Flash Hood)',
    category: 'fire-retardants',
    categoryName: 'Fire Retardants',
    categoryImage: 'PLACEHOLDER',
    shortDescription: 'Head and neck protection against heat and flame.',
    technicalDescription:
      'Double-layer knitted hood made from Nomex/Lenzing FR blend. Provides protection for the head, neck, and face against flash fire and radiant heat.',
    sectors: ['defence', 'police'],
    variants: ['Natural', 'Navy Blue', 'Black'],
    configuration: 'One size fits most, elasticated face opening',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Police', use: 'Public order flame protection' },
      { sector: 'Defence', use: 'Vehicle crew flash protection' },
    ],
    specifications: [
      { field: 'Material', value: 'Nomex / Viscose Blend' },
      { field: 'Standard', value: 'EN 13911' },
      { field: 'Construction', value: 'Interlock Knit' },
      { field: 'Seams', value: 'Flatlock' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },

  // Public Order
  {
    slug: 'riot-shield',
    name: 'Interlocking Riot Shield',
    category: 'public-order',
    categoryName: 'Public Order / Control and Restraint',
    categoryImage: 'PLACEHOLDER',
    shortDescription:
      'Polycarbonate shield for crowd control and ballistic protection.',
    technicalDescription:
      'Manufactured from high-impact transparent polycarbonate. Features an interlocking edge design to allow officers to form a solid barrier wall. Ergonomic handle system for prolonged use.',
    sectors: ['police', 'prisons'],
    variants: ['Round', 'Rectangular', 'Short', 'Long'],
    configuration: 'Ambidextrous handle, forearm strap',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Police', use: 'Crowd control lines' },
      { sector: 'Prisons', use: 'Cell entry protection' },
    ],
    specifications: [
      { field: 'Material', value: '4mm Polycarbonate' },
      { field: 'Transparency', value: '> 85%' },
      { field: 'Impact Strength', value: 'High' },
      { field: 'Weight', value: '3.5 kg (Long)' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },
  {
    slug: 'restraint-kit',
    name: 'Soft Restraint Kit',
    category: 'public-order',
    categoryName: 'Public Order / Control and Restraint',
    categoryImage: 'PLACEHOLDER',
    shortDescription: 'Fabric-based restraint system for safe subject control.',
    technicalDescription:
      'A complete kit comprising limb restraints and a torso belt. Designed to restrict movement safely without causing injury, using soft, wide webbing straps and secure hook-and-loop fasteners.',
    sectors: ['police', 'prisons', 'medical'],
    variants: ['Standard Kit', 'Heavy Duty'],
    configuration: 'Includes carry bag and instruction card',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Prisons', use: 'Safe relocation of non-compliant prisoners' },
      { sector: 'Medical', use: 'Patient restraint in secure mental health' },
    ],
    specifications: [
      { field: 'Webbing', value: 'Polyester / Nylon' },
      { field: 'Strength', value: 'Rated to 500kg' },
      { field: 'Fasteners', value: 'Velcro / Buckle' },
      { field: 'Washable', value: 'Yes' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },
  {
    slug: 'body-worn-camera-harness',
    name: 'Body Worn Camera Harness',
    category: 'public-order',
    categoryName: 'Public Order / Control and Restraint',
    categoryImage: 'PLACEHOLDER',
    shortDescription: 'Secure mounting solution for evidence capture devices.',
    technicalDescription:
      'Adjustable chest harness designed to securely hold body-worn video cameras. Ensures a stable, central viewpoint for evidence gathering, compatible with major camera brands.',
    sectors: ['police', 'prisons'],
    variants: ['Klick Fast Dock', 'MOLLE Mount'],
    configuration: 'Fully adjustable straps, quick release',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Police', use: 'Evidence gathering on patrol' },
      { sector: 'Prisons', use: 'Incident recording' },
    ],
    specifications: [
      { field: 'Material', value: 'Nylon Webbing / Mesh' },
      { field: 'Mount', value: 'Universal or Specific' },
      { field: 'Adjustability', value: 'One size fits all' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },

  // Tactical Vests
  {
    slug: 'plate-carrier-vest',
    name: 'Modular Plate Carrier',
    category: 'tactical-vests',
    categoryName: 'Tactical Vests',
    categoryImage: 'PLACEHOLDER',
    shortDescription:
      'Lightweight ballistic plate carrier for high-mobility operations.',
    technicalDescription:
      'Minimalist plate carrier designed to hold hard armour plates (front and back). Features laser-cut MOLLE for pouch attachment and skeletal cummerbund for ventilation.',
    sectors: ['defence', 'police'],
    variants: ['Multicam', 'Black', 'Coyote', 'Ranger Green'],
    configuration: 'Accepts SAPI/ESAPI plates',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Defence', use: 'Direct action operations' },
      { sector: 'Police', use: 'Counter-terrorism response' },
    ],
    specifications: [
      { field: 'Material', value: '500D Laminate' },
      { field: 'Weight', value: '0.8 kg (carrier only)' },
      { field: 'Size', value: 'Adjustable' },
      { field: 'Release', value: 'Quick release buckles' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },
  {
    slug: 'load-bearing-vest',
    name: 'Tactical Load Bearing Vest',
    category: 'tactical-vests',
    categoryName: 'Tactical Vests',
    categoryImage: 'PLACEHOLDER',
    shortDescription: 'Non-ballistic vest for equipment carriage.',
    technicalDescription:
      'Mesh-based vest designed to distribute the weight of equipment across the torso. Features fixed or modular pouches for magazines, communications, and utilities.',
    sectors: ['defence', 'police'],
    variants: ['Fixed Pouch', 'MOLLE Modular'],
    configuration: 'Zip front, adjustable sides',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Defence', use: 'Training and non-combat roles' },
      { sector: 'Police', use: 'Dog handler equipment carriage' },
    ],
    specifications: [
      { field: 'Base Material', value: 'Heavy Duty Mesh' },
      { field: 'Pouch Material', value: '1000D Nylon' },
      { field: 'Zips', value: 'YKK' },
      { field: 'Adjustment', value: 'Shock cord / Webbing' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },
  {
    slug: 'covert-stab-vest',
    name: 'Covert Stab/Ballistic Vest',
    category: 'tactical-vests',
    categoryName: 'Tactical Vests',
    categoryImage: 'PLACEHOLDER',
    shortDescription:
      'Concealable protection for undercover or civilian-attire roles.',
    technicalDescription:
      'Low-profile carrier designed to be worn under clothing. Holds soft armour panels providing protection against stab, spike, and handgun threats.',
    sectors: ['police', 'prisons'],
    variants: ['White', 'Black', 'Beige'],
    configuration: 'Moisture-wicking lining, 4-point adjustment',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Police', use: 'CID / Undercover protection' },
      { sector: 'Prisons', use: 'Governor / Staff protection' },
    ],
    specifications: [
      { field: 'Fabric', value: 'Coolmax / Poly-cotton' },
      { field: 'Protection', value: 'Carrier for KR1/SP1/HG1' },
      { field: 'Profile', value: 'Ultra-thin' },
      { field: 'Washable', value: 'Yes (panels removed)' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },

  // Training Equipment
  {
    slug: 'training-suit-set',
    name: 'RedMan Training Suit',
    category: 'training-equipment',
    categoryName: 'Training Equipment',
    categoryImage: 'PLACEHOLDER',
    shortDescription: 'Full-body protective suit for reality-based training.',
    technicalDescription:
      'High-impact foam suit designed to protect the wearer during blunt force training scenarios. Allows for full-force defensive tactics training with batons and physical strikes.',
    sectors: ['police', 'prisons', 'defence'],
    variants: ['Red (Instructor)', 'Black (Student)'],
    configuration: 'Head, torso, limb, and joint protection',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Police', use: 'Officer safety training' },
      { sector: 'Prisons', use: 'C&R instructor training' },
    ],
    specifications: [
      { field: 'Material', value: 'Dipped Foam' },
      { field: 'Impact Absorption', value: 'High' },
      { field: 'Sanitisation', value: 'Wipe clean' },
      { field: 'Components', value: '14 piece set' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },
  {
    slug: 'scenario-target-system',
    name: 'Scenario Target System',
    category: 'training-equipment',
    categoryName: 'Training Equipment',
    categoryImage: 'PLACEHOLDER',
    shortDescription:
      'Interactive targets for firearms and decision-making training.',
    technicalDescription:
      'Range of paper and polymer targets depicting various threat/no-threat scenarios. Designed to improve reaction times and decision making in use-of-force situations.',
    sectors: ['defence', 'police'],
    variants: ['Paper', '3D Polymer', 'Reactive'],
    configuration: 'Standard range mount compatible',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Defence', use: 'Close quarters battle (CQB) training' },
      { sector: 'Police', use: 'Authorised firearms officer qualification' },
    ],
    specifications: [
      { field: 'Material', value: 'Paper / Polymer' },
      { field: 'Dimensions', value: 'Life-size' },
      { field: 'Print', value: 'High definition' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },
  {
    slug: 'protective-training-helmet',
    name: 'Protective Training Helmet',
    category: 'training-equipment',
    categoryName: 'Training Equipment',
    categoryImage: 'PLACEHOLDER',
    shortDescription: 'Head protection for physical training scenarios.',
    technicalDescription:
      'Lightweight helmet with face cage, designed to protect against accidental strikes and falls during physical intervention training. Provides visibility and ventilation while ensuring safety.',
    sectors: ['police', 'prisons'],
    variants: ['Blue', 'Red', 'Black'],
    configuration: 'Adjustable chin strap, removable cage',
    leadTime: 'Subject to specification and order volume',
    applications: [
      { sector: 'Prisons', use: 'Control and restraint training' },
      { sector: 'Police', use: 'Unarmed combat training' },
    ],
    specifications: [
      { field: 'Shell', value: 'ABS Plastic' },
      { field: 'Liner', value: 'Impact Foam' },
      { field: 'Cage', value: 'Steel Wire' },
      { field: 'Certification', value: 'CE Marked' },
    ],
    image: 'PLACEHOLDER',
    gallery: ['PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER', 'PLACEHOLDER'],
  },
]
